// USA
export const locale = {
    GENERAL: {
      APP_TITLE: "VIMS",
      UNEXPECTED_ERROR: "Unexpected error! Please contact the technical team if the problem persist.",
      FORBIDDEN:"You do not have the right permissions.",
      DELETE_CONFIRM: "Please confirm delete!",
      SELECT_ALL_CONFIRM: "Please confirm all select/deselect!",
      SUCCESS_MESSAGE: "Success!",
      SUCCESS_UPDATE_MESSAGE: "Successfully updated!",
      LABELS: {
        CONTINUE_BUTTON: "Continue",
        BACK_BUTTON: "Back",
        DOWNLOAD_BUTTON: "Download",
        CREATE_BUTTON: "Create",
        ALL: "All",
        SELECT_ALL_OPTION: "Select All",
        PHONE: "Phone",
        SAVE: "Save",
        EDIT: "Edit",
        EDIT_BUTTON: "Edit",
        CLOSE_BUTTON: "Close",
        RELOAD_PAGE: "Reload Page",
        ORDER: "Order",
        OFFER_GROUP: "Offer Group",
        SEARCH: "Search",
        SHOW_ONLY_SELECTED: "Only Selected",
        ADD_NEW_BELOW: "Add New Below",
        HEADERS: "Headers",
        SEARCH: "Search",
        TEMPERATURE: "Temperature",
        ORDER: "Order",
        LEAD: "Lead",
        FILTER: "Filter",
        CONVERTED_FROM: "Converted From",
        EXCHANGE_RATE: "Exchange Rate",
        UNCONVERTED_PRICE: "Unconverted Price",
        NAME: "Name",
        ID: "ID",
        EMAIL: "Email",
        TYPE: "Type",
        DATE_TYPE: "Date Type",
        FOUND: "Found",
        CONTACTS: "Contacts",
        PERSONALIZED_WEEKLY_OFFER_CONTACTS: "PWO Contacts",
        COMPANY: "Company",
        SELECTED: "Selected",
        WEEK: "Week",
        START_DATE: "Start Date",
        END_DATE: "End Date",
        LIST_OF_THE_CONTACTS: "List of the Contacts",
        EXPAND_ALL: "Expand All",
        COLLAPSE_ALL: "Collapse All",
        ADDITIONAL_COLUMNS: "Additional Columns",
        FILTERS: "Filters",
        REFRESH_DATA: "Refresh Data",
        CLOSE: "Close",
        CLOSE_AND_SELECT: "Close and Select",
        CONFIRM_TITLE: "Are you sure?",
        YES: "Yes",
        NO: "No",
        CODE: "Code",
        STATUS: "Status",
        TEMPERATURE: "Temperature",
        CREATED_BY: "Created By",
        CREATED_DATE: "Created Date",
        PUBLISHED_BY: "Published By",
        PUBLISHED_DATE: "Published Date",
        OPEN: "Open",
        COPY: "Copy",
        PRINT_VIEW: "Print View",
        DOWNLOAD: "Download",
        PREVIEW: "Preview",
        SHOW_RELATED_CONTACTS: "Show Related Contacts",
        CURRENCY: "Currency",
        COUNTRY: "Country",
        EXPIRATION_DATE: "Expiration Date",
        TRANSPORT_COST: "Transport Cost",
        LAST_UPDATED: "Last Updated",
        ADD_TRANSPORT_DATA: "Add Transport Data",
        SAME_COUNTRIES: "Same Countries",
        CUSTOM_TRANSPORT_COST: "Custom Transport Cost",
        LOADING_COUNTRY: "Loading Country",
        CLIENT_PRICE: "Client Price",
        MISSING_TRANSPORT_COSTS: "Missing Transport Costs",
        DELETE: "Delete",
        CONTACTS_LOADING: "Contacts Loading",
        REFRESH_PRICE_LIST: "Refresh Price List",
        NEW_POSITIONS: "New Positions",
        UPDATED_POSITIONS: "Updated Positions",
        DELETED_POSITIONS: "Deleted Positions",
        NO_CHANGES: "No Changes",
        APPROVE: "Approve",
        COST_BASE: "Cost Base",
        LEAD_OFFER: "Lead Offer",
        OFFER: "Offer",
        INCOTERMS: "Incoterms",
        INCOTERM_NAMED_PLACE: "Incoterm named place",
        DESTINATION_COUNTRY: "Destination Country",
        PRICE_LISTS: "Price Lists",
        REQUEST_QUOTE: "Request a quote",
        DATE: "Date",
        SHOW_OLDER: "Show Older",
        MATCH_TYPE: "Match Type",
        PRICE: "Price",
        POSITION_NAME: "Position Name",
        TRANSPORT_PRICE: "Transport Price",
        TOTAL_PRICE: "Total Price",
        PRICE_LIST: "Price List",
        REFRESH: "Refresh",
        OPEN_IN_LIVE_LIST: "Open in Live List",
        IMPORT_TYPE: "Import Type",
        CHOOSE_FILE: "Choose File",
        DOWNLOAD_TEMPLATE: "Download Template",
        PLEASE_CHOOSE_FILE: "Please choose file",
        COPY: "Copy",
        ACTIVE: "Active",
        INACTIVE: "Inactive",
        CANCEL: "Cancel",
        NOTES: "Notes",
        DESCRIPTION: "Description",
        CONTACT: "Contact",
      },
      TABLE: {
        OPTIONS_COLUMN: "Options",
        TOTAL_ITEMS: "Total Items",
        RESET_COLUMNS: "Reset columns",
      }
    },
    TRANSLATOR: {
        SELECT: "Select your language"
    },
    MENU: {
        NEW: "new",
        ACTIONS: "Actions",
        CREATE_POST: "Create New Post",
        PAGES: "Pages",
        FEATURES: "Features",
        APPS: "Apps",
        DASHBOARD: "Dashboard",
        ASIDE: {
            OFFER: "Offer",
            QUICK_ADD: "Quick Add",
            LIST_OFFERS: "List Offers",
            LIVE_LIST: "Live List",
            PRICE_LISTS: "Price Lists",
            PRICING: "Pricing",
            COMPANIES: "Companies",
            COMPANY_CONTACTS: "Company Contacts",
            PIPELINES: "Pipelines",
            CREATE_PIPELINE: "Create Pipeline",
            LIST_PIPELINES: "List Pipelines",
            DEALS: "Deals",
            DEALS_LIST: "Deals List",
            DEAL_TYPES: "Deal Types",
            DEAL_STATUSES: "Deal Statuses",
            DEAL_DOCUMENT_TYPES: "Deal Document Types",
            STOCK: "Stock",
            STOCK_SETTINGS: "Stock Settings",
            STOCK_WAREHOUSES: "Warehouses",
            STOCK_PRODUCTS: "Products",
            STOCK_PRODUCT_CATEGORIES: "Categories",
            STOCK_PRODUCT_DEPARTMENTS: "Departments",
            STOCK_PACKAGINGS: "Packagings",
            STOCK_UNITS: "Units",
            STOCK_INVENTORY: "Inventory",
            STOCK_AVERAGE_COSTS: "Average cost",
            STOCK_PURCHASE_ORDERS: "Purchase orders",
            STOCK_SALES_ORDERS: "Sales orders",
            STOCK_TRANSPORT_ORDERS: "Transport orders",
            STOCK_INVOICES: "Invoices",
            STOCK_MOVEMENTS: "Stock movements",
            STOCK_REVISIONS: "Stock revisions",
            STOCK_TRANSFER_ORDERS: "Transfer orders",
            STOCK_PRODUCT_MOVEMENTS: "Product movements",
            STOCK_RECEIPTS: "Receipts",
            STOCK_SALES: "Deliveries",
            SETTINGS: "Settings",
            USERS: "Users",
            TEAMS: "Teams",
            ALIASES: "Aliases",
            MAPPINGS: "Mappings",
            UNIT_CONVERSIONS: "Unit Conversions",
            TRANSPORT_DATA: "Transport Data",
            FIELD_TAGS: "Field Tags",
            INCOTERMS: "Incoterms",
            PRICE: "Price"
        }
    },
    AUTH: {
        GENERAL: {
            WELCOME: "Welcome to Adex VIMS!",
            WELCOME_DESCRIPTION:
                "Virtual Inventory Management System for offer solutions",
            FOOTER_LEFT: "Adex",
            OR: "Or",
            SUBMIT_BUTTON: "Submit",
            NO_ACCOUNT: "Don't have an account?",
            SIGNUP_BUTTON: "Sign Up",
            FORGOT_BUTTON: "Forgot Password",
            BACK_BUTTON: "Back",
            PRIVACY: "Privacy",
            LEGAL: "Legal",
            CONTACT: "Contact"
        },
        LOGIN: {
            TITLE: "Login Account",
            DESCRIPTION:
                "Please contact the website Administrator to obtain username and password.",
            VALID_EMAIL: "A valid email address is required.",
            VALID_PASSWORD: "Password is required.",
            BUTTON: "Sign In",
            CREDENTIALS_ERROR: "Wrong username or password.",
            GOOGLE_EMAIL_ERROR: "Invalid account.",
            VALID_PASSWORD_CONFIRM: "Passwords must match",
            LOGIN_BUTTON: "Login"
        },
        FORGOT: {
            TITLE: "Forgot Password?",
            DESC: "Success. Enter your email to reset your password",
            SUCCESS: "Your account has been successfully reset.",
            BUTTON: "Send",
            SUCCESS_MESSAGE:
                "You have received an email with link to reset your password."
        },
        RESET: {
            TITLE: "Reset Password",
            BUTTON: "Save",
            SUCCESS_MESSAGE: "Success. Please login with your new password."
        },
        REGISTER: {
            TITLE: "Sign Up",
            DESC: "Enter your details to create your account",
            SUCCESS: "Your account has been successfuly registered."
        },
        INPUT: {
            EMAIL: "Email",
            FULLNAME: "Fullname",
            PASSWORD: "Password",
            CONFIRM_PASSWORD: "Confirm Password",
            USERNAME: "Username"
        },
        VALIDATION: {
            INVALID: "{{name}} is not valid",
            REQUIRED: "{{name}} is required",
            MIN_LENGTH: "{{name}} minimum length is {{min}}",
            AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
            NOT_FOUND: "The requested {{name}} is not found",
            INVALID_LOGIN: "The login detail is incorrect",
            REQUIRED_FIELD: "Required field",
            MIN_LENGTH_FIELD: "Minimum field length:",
            MAX_LENGTH_FIELD: "Maximum field length:",
            INVALID_FIELD: "Field is not valid"
        }
    },
    PROFILE: {
      PROFILE_BUTTON: "Profile",
      LOG_OUT_BUTTON: "Sign Out",
      INFO_HEADER: "Profile Information",
      DISPLAY_PREFERENCES_HEADER: "Display Preferences",
      NAME_LABEL: "Name",
      EMAIL_LABEL: "Email"
    },
    OFFER: {
        TITLE: "Offer",
        SUB_TITLE: "Add New Offer",
        PREVIEW_TITLE: "Offer Preview",
        SECTION_GENERAL: "General",
        SECTION_TAGS: "Tags",
        SECTION_MAPPINGS: "Mapping Values",
        SECTION_NORMALIZE: "Derived Fields"
    },
    LIST_OFFERS: {
        TITLE: "List Offers",
        SUB_TITLE: "List All Offers",
        DATE: "Date",
        EXPIRE_DATE: "Expire Date",
        RAW: "Raw"
    },
    NEW_QUICK_OFFER: {
        TITLE: "Create Quick Offer",
        SUB_TITLE: "New Quick Offer"
    },
    USERS: {
        TITLE: "Users",
        SUB_TITLE: "Users",
        SYSTEM_ADMIN: "System Admin",
        ORGANIZATIONS: "Organizations",
        ORGANIZATIONS_HINT: "If none are selected, the user can operate with all organizations. Selecting one or more limits the user to those organizations, including the global filter.",
        LABELS: {
          GOOGLE_LOGIN: "Google Login"
        }
    },
    TEAMS: {
        TITLE: "Teams",
        SUB_TITLE: "Teams",
        USERS: "Users",
        NEED_OFFERS_PERRMISSION_WARNING: "Need Offers Permission",
    },
    COMPANY_CONTACTS: {
        TITLE: "Company Contacts",
        SUB_TITLE: "Company Contacts",
        CREATE: "Create Company Contact",
        EDIT: "Update Company Contact",
        VIEW: "View Company Contact",
        ROLE: "Role",
    },
    COMPANIES: {
        TITLE: "Companies",
        CREATE: "Create Company",
        EDIT: "Update Company",
        VIEW: "View Company",
        ADD_NEW: "Add New Company",
        CREATED_MESSAGE: "Company {name} was added.",
        COMPANY_RANK: "Company Rank",
        COMPANY_TYPES: "Company Types",
        COMPANY_CONTACTS_COUNT: "Company Contacts Count",
        OPEN_CONTACTS: "Open Contacts",
        FILTERED_COMPANIES_COUNT: "{count} companies",
        NO_COMPANIES_FOR_CONTACTS: "No companies found for the current filters.",
        TOO_MANY_COMPANIES_FOR_CONTACTS: "More than {max} companies is too many. Please narrow your filters.",
        VAT: "VAT",
        CREDIT_LIMIT: "Credit Limit",
        ADDRESS: "Address",
        ADDRESS_BUILDER: "Build address",
        ADDRESS_BUILDER_TITLE: "Address builder",
        ADDRESS_BUILDER_HINT: "Fill in only the fields you need. The filled parts will be combined into one address.",
        ADDRESS_STREET: "Street address",
        ADDRESS_STREET_2: "Apartment, suite, unit, etc.",
        ADDRESS_CITY: "City",
        ADDRESS_STATE: "State / Province / Region",
        ADDRESS_POSTAL_CODE: "Postal code",
        ADDRESS_COUNTRY: "Country",
        ADDRESS_PREVIEW: "Preview",
        ADDRESS_PREVIEW_EMPTY: "Filled address parts will appear here.",
        ADDRESS_APPLY: "Apply to address",
        ADDRESS_CLEAR: "Clear fields",
        NOTES: "Notes",
        WEBSITE: "Website",
        OWNED_BY: "Owned By",
        GENERAL_EMAILS: "General Emails",
        ADD_GENERAL_EMAIL: "Add General Email",
        EMAIL_TAGS: "Role",
        REPRESENTS_ORGANIZATION: "Represents our organization (intercompany)",
        REPRESENTS_ORGANIZATION_HINT:
            "Set this when the counterparty is one of our own organizations. Enables intercompany dropship automation.",
    },
    PIPELINES: {
        TITLE: "Pipelines",
        CREATE: "Create Pipeline",
        EDIT: "Update Pipeline",
        VIEW: "View Pipeline",
        NO_STAGES_IN_PIPELINE: "No stages in this pipeline.",
        TOO_MANY_DEALS_WARNING:
            "This pipeline has {count} deals on the board. Performance may be slower with this many deals.",
        VIEW_BOARD: "Board",
        VIEW_TABLE: "Table",
        STAGES: "Stages",
        STAGE_NAME: "Stage name",
        STAGE_ORDER_INTEGER: "Order must be a whole number.",
        STAGE_ORDER_MIN: "Order must be 0 or greater.",
        ADD_STAGE: "Add stage",
        MIN_STAGES: "At least two stages are required.",
    },
    DEAL_TYPES: {
        TITLE: "Deal Types",
        CREATE: "Create Deal Type",
        EDIT: "Edit Deal Type",
        SLUG: "Slug",
        TYPE: "Type",
        SYSTEM: "System",
        CUSTOM: "Custom",
        SYSTEM_EDIT_DISABLED: "System deal types cannot be edited.",
    },
    FIELD_TAGS: {
        TYPES_TITLE: "Field Tag Types",
        TAGS_TITLE: "Field Tags",
        CREATE_TYPE: "Create Field Tag Type",
        EDIT_TYPE: "Edit Field Tag Type",
        CREATE_TAG: "Create Field Tag",
        EDIT_TAG: "Edit Field Tag",
        MERGE_INTO_CURRENT_TOOLTIP: "Merge similar tags into this tag",
        MERGE_CURRENT_INTO_OTHER_TOOLTIP: "Merge this tag into another",
        MERGE_INTO_CURRENT_TITLE: "Merge tags into this tag",
        MERGE_CURRENT_INTO_OTHER_TITLE: "Merge this tag into another",
        MERGE_TAGS_TITLE: "Merge tags",
        CURRENT_TAG: "Current tag",
        NO_MERGE_SUGGESTIONS: "No suggestions found with at least 50% similarity.",
        SELECT_TAGS_TO_MERGE_INTO_CURRENT: "Select tags to merge into this tag",
        SELECT_TARGET_TAG: "Select target tag",
        MERGE_BUTTON: "Merge",
        CANCEL_BUTTON: "Cancel",
    },
    INCOTERMS: {
        TITLE: "Incoterms",
        CREATE: "Create Incoterm",
        EDIT: "Edit Incoterm",
        CODE: "Code",
        INCLUDE_TRANSPORT: "Include Transport",
        YES: "Yes",
        NO: "No",
    },
    DEAL_STATUSES: {
        TITLE: "Deal Statuses",
        CREATE: "Create Deal Status",
        EDIT: "Edit Deal Status",
        SLUG: "Slug",
        TYPE: "Type",
        SYSTEM: "System",
        CUSTOM: "Custom",
        SYSTEM_EDIT_DISABLED: "System deal statuses cannot be edited.",
    },
    DEAL_DOCUMENT_TYPES: {
        TITLE: "Deal Document Types",
        CREATE: "Create Deal Document Type",
        EDIT: "Edit Deal Document Type",
        SLUG: "Slug",
        TYPE: "Type",
        REQUIRED: "Required",
        SYSTEM: "System",
        CUSTOM: "Custom",
        SYSTEM_EDIT_LIMITED: "System document types can only have the Required field edited.",
    },
    DEALS: {
        TITLE: "Deals",
        TABLE: {
            PIPELINE: "Pipeline",
        },
        MODAL: {
            ADD_DEAL_BUTTON: "Add deal",
            DEAL_FALLBACK_TITLE: "Deal #{id}",
            NO_DEALS: "No deals",
            ADD_TITLE: "Add deal",
            EDIT_TITLE: "Edit deal",
            VIEW_TITLE: "View deal",
            DEAL_NAME: "Deal name",
            DEAL_NUMBER: "Deal number",
            ORGANIZATION: "Organization",
            SUPPLIER: "Supplier",
            SUPPLIERS: "Suppliers",
            CLIENT: "Client",
            CLIENTS: "Clients",
            PIPELINE: "Pipeline",
            STAGE: "Stage",
            MEAT: "Meat",
            DESCRIPTION: "Description",
            PRODUCTS: "Products",
            ADD_PRODUCT: "Add product",
            CONTAINER_ARRIVAL_DATE: "Container arrival date",
            CONTAINER_NUMBER: "Container number",
            LOADING_DATES: "Loading dates",
            LOADING_DATE: "Loading date",
            YEAR: "Year",
            WEEK: "Week",
            ADD_LOADING_DATE: "Add loading date",
            NOTE: "Note",
            TYPE: "Type",
            INCOTERM: "Incoterm",
            LOCATION: "Location",
            STATUS: "Status",
            IS_PAID: "Paid",
            PAID_YES: "Yes",
            PAID_NO: "No",
            FILES: "Files",
            OTHER_FILES: "Other Files",
            TAB_INFORMATION: "Information",
            TAB_DOCUMENTS: "Documents",
            REQUIRED_DOCUMENT: "Required",
            MISSING_REQUIRED_DOCUMENT: "This document is required",
            UPLOAD_DOCUMENT_HINT: "Click or drag a file to upload",
            COMPLETE_MISSING_DOCUMENTS_CONFIRM: "Are you sure you want to complete this deal? The following required documents are missing: {documents}.",
            FILES_AVAILABLE_AFTER_SAVE: "Files can be uploaded after the deal is saved.",
            DROP_FILES_HINT: "Drag and drop files here or click to upload",
            NO_FILES: "No files uploaded",
        },
        VIEW: {
            OVERVIEW: "Overview",
            DOCUMENTS: "Documents",
            COMMENTS: "Comments",
            NO_DOCUMENTS: "No linked documents",
            GENERATED_FILES: "Generated files",
            UPLOADED_FILES: "Uploaded files",
            QUICK_ACTIONS: "Quick actions",
            NEW_PO: "New purchase order",
            NEW_SO: "New sales order",
            NEW_RECEIPT: "New receipt",
            NEW_DELIVERY: "New delivery",
            ACTIVITY: "Deal activity",
            WORKFLOW: "Workflow",
            NO_ACTIVITY: "No documents linked to this deal yet",
            CREATE_PO_FROM_SO: "Create PO from SO",
            LINKED_TO: "Linked to",
            OUTBOUND: "Outbound",
            INBOUND: "Inbound",
            STANDALONE: "Other documents",
            STANDALONE_CHAIN: "Transport",
            RELATED: "related",
            FILES: "files",
            PENDING_ACTIONS: "pending actions",
            RECEIPTS_SHORT: "receipts",
            DELIVERIES_SHORT: "deliveries",
        },
        CUSTOMER_REQUESTS: {
            TITLE: "Customer request",
            SUBTITLE: "Add lines as products, free text, or mappings — with quantity on every line.",
            NEW: "Add Customer request",
            EDIT: "Edit request",
            EMPTY: "No customer request recorded for this deal yet.",
            STATUS: "Status",
            REQUEST_DATE: "Request date",
            CREATED_BY: "Created by",
            NOTES: "Request notes",
            NOTES_HINT: "Describe the customer need in detail so colleagues can follow up.",
            CRITERIA: "Request criteria",
            LINES: "Requested lines",
            NO_LINES: "No lines added yet.",
            LINES_REQUIRED: "Add at least one line with quantity.",
            ADD_LINE: "Add line",
            REQUESTED_QTY: "Requested quantity",
            LINE_NOTES: "Line notes",
            LINE_CONTENT: "Line",
            LINE_SOURCE: "How do you want to describe this line?",
            LINE_SOURCE_PRODUCTS: "Products",
            LINE_SOURCE_FREE_TEXT: "Free text",
            LINE_SOURCE_MAPPING: "Mapping",
            LINE_TITLE: "Name",
            LINE_TITLE_HINT: "Name of what is being requested. Notes are for payment, transport, and other remarks.",
            MATCHED_PRODUCTS: "Candidate products",
            SELECTED_PRODUCTS: "Selected products for this line",
            CUSTOMER_PRODUCT: "Customer product",
            CUSTOMER_PRODUCT_NAME: "Customer product name",
            CUSTOMER_PRODUCT_CODE: "Customer product code",
            QUANTITY: "Quantity",
            UNIT: "Unit",
            MATCHED_PRODUCT: "Matched product",
            MATCH_PRODUCTS: "Search products",
            MATCH_HINT: "Use search and filters (tags, category, temperature…) like in PO/SO.",
            DELETE_CONFIRM: "Delete this customer request?",
            SAVE: "Save request",
            STATUS_HISTORY: "Status history",
            NO_STATUS_HISTORY: "No status changes yet.",
            STATUS_CHANGED_BY: "by {name}",
            ACTIONS: {
                SUBMIT: "Submit",
                BACK_TO_DRAFT: "Back to draft",
                ONGOING: "Ongoing",
                BLOCKED: "Blocked",
                FINISHED: "Finished",
            },
            STATUSES: {
                DRAFT: "Draft",
                SUBMITTED: "Submitted",
                ONGOING: "Ongoing",
                BLOCKED: "Blocked",
                FINISHED: "Finished",
            },
        },
        CUSTOMER_OFFERS: {
            TITLE: "Customer offer",
            SUBTITLE: "Add lines as products, free text, or mappings — with quantity on every line.",
            NEW: "Add Customer offer",
            EDIT: "Edit offer",
            EMPTY: "No customer offer recorded for this deal yet.",
            NOTES: "Offer notes",
            NOTES_HINT: "Describe what the customer is offering so colleagues can find buyers.",
            CRITERIA: "Offer criteria",
            LINES: "Offered lines",
            LINES_REQUIRED: "Add at least one line with quantity.",
            REQUESTED_QTY: "Offered quantity",
            LINE_TITLE_HINT: "Name of what is being offered. Notes are for payment, transport, and other remarks.",
            DELETE_CONFIRM: "Delete this customer offer?",
            SAVE: "Save offer",
        },
        TRADE_SIDE: {
            LABEL: "Trade side",
            BUYING: "Buying",
            SELLING: "Selling",
        },
    },
    COMMENTS: {
        ADD: "Add a comment",
        POST: "Post comment",
        EMPTY: "No comments yet",
    },
    STOCK: {
        COMMON: {
            OPEN_DEAL: "Open deal",
            LOT_QTY_AVAILABLE: "{available} {unit} available",
            LOT_QTY_EXCEEDS_AVAILABLE: "Exceeds lot ({available} {unit} available)",
            LOT_QTY_VALIDATION_BLOCKED:
                "One or more lines exceed the available lot quantity.",
            UNIT_COST_AVG: "Unit cost (avg.)",
            GROSS_WEIGHT_KG: "Gross kg",
            EFFECTIVE_UNIT_COST: "Effective unit cost",
            INVENTORY_COST_NET: "Inventory cost (net)",
            COST_OF_GOODS_NET: "COGS (net)",
            MARGIN_NET: "Margin (net)",
            MARGIN_PCT: "Margin %",
            TOTALS_SALE_FINANCIAL:
                "Net {net} · COGS {cogs} · Margin {margin} ({marginPct}%) · VAT {vat} · Gross {gross}",
            TOTALS_RECEIPT_INVENTORY:
                "Net {net} · Inventory cost {inventoryCost} · VAT {vat} · Gross {gross}",
            RELATED_TRANSPORT_ORDERS: "Related transport orders",
            NO_RELATED_TRANSPORT_ORDERS: "No related transport orders",
            RELATED_PURCHASE_ORDERS: "Related purchase orders",
            NO_RELATED_PURCHASE_ORDERS: "No related purchase orders",
            RELATED_SALES_ORDERS: "Related sales orders",
            NO_RELATED_SALES_ORDERS: "No related sales orders",
            RELATED_RECEIPTS: "Related receipts",
            NO_RELATED_RECEIPTS: "No related receipts",
            RELATED_DELIVERIES: "Related deliveries",
            NO_RELATED_DELIVERIES: "No related deliveries",
            RELATED_INVOICES: "Related invoices",
            NO_RELATED_INVOICES: "No related invoices",
        },
        DOCUMENTS: {
            TITLE: "Documents",
            SYSTEM_DOCUMENTS: "System documents",
            ATTACHMENTS: "Attachments",
            GENERATED: "Generated",
            TYPE_TRANSPORT_ORDER: "Transport order",
            DOWNLOAD_ALL: "Download all",
            REGENERATE: "Regenerate PDF",
            GENERATE_PDF: "Generate PDF",
            GENERATE_DOCUMENT: "Generate document",
            REGENERATE_DOCUMENT: "Regenerate document",
            GENERATE_TRANSPORT_ORDER: "Generate transport order",
            REGENERATE_TRANSPORT_ORDER: "Regenerate transport order",
            NO_TRANSPORT_ORDER_DOCUMENT: "Transport order document is not generated yet",
            NO_SYSTEM_DOCUMENT:
                "No system PDF yet. It is created automatically when the purchase order is confirmed (not when stock is received).",
            DROP_FILES_HINT: "Drop files here or click to upload",
            RELATED_SHIPMENT_FILES_HINT:
                "Generated CMR and trade documents from the Shipments tab also appear here for download.",
            NO_ATTACHMENTS: "No attachments uploaded",
            ORG_AND_WAREHOUSE_REQUIRED_SAVE:
                "Organization and destination warehouse are required.",
            DISCARD: "Discard",
            CONFIRM_DISCARD: "Discard this draft? It will be removed completely.",
        },
        CONTEXT: {
            ORGANIZATIONS: "Organizations",
            WAREHOUSES: "Warehouses",
        },
        WAREHOUSES: {
            TITLE: "Warehouses",
            CREATE: "Create Warehouse",
            EDIT: "Edit Warehouse",
            CODE: "Code",
            ORGANIZATION: "Organization",
            VIRTUAL_SUBTYPE: "Virtual subtype",
            ADDRESS: "Address",
            CONTACT_NAME: "Contact name",
            CONTACT_PHONE: "Contact phone",
            STORAGE_CAPABILITIES: "Storage capabilities",
            NOTICE_HOURS: "Notice hours",
            CAPACITY_PALETTES: "Capacity palettes",
            USER_ACCESS: "User access",
            SYSTEM: "System",
            CUSTOM: "Custom",
            TYPES: {
                PHYSICAL: "Physical",
                VIRTUAL: "Virtual",
            },
            VIRTUAL_SUBTYPES: {
                TRANSIT: "Transit",
                DROPSHIP: "Drop-ship",
                QUARANTINE: "Quarantine",
                CONSIGNMENT: "Consignment",
                CONTAINER: "Container",
                LAND: "Land",
            },
        },
        PRODUCT_FINDER: {
            TITLE: "Find products to add",
            SEARCH: "Search",
            CLEAR: "Clear filters",
            SEARCH_HINT: "Set at least one filter (department, category, temperature, tags) or enter at least 2 characters, then click Search.",
            SEARCH_HINT_WITH_MAPPING: "Set at least one filter (department, category, temperature, tags, meat, description) or enter at least 2 characters, then click Search.",
            NO_RESULTS: "No products match your filters.",
            RESULTS_COUNT: "{count} product(s) found",
            ADD_TO_LINES: "Add to lines",
            EMPTY_LINES: "No lines yet. Use the product finder above to add items.",
        },
        PRODUCTS: {
            TITLE: "Products",
            CREATE: "Create Product",
            EDIT: "Edit Product",
            PRODUCT: "Product",
            CODE: "HS/CN/TARIC Code",
            DISPLAY_NAME: "Display name",
            DISPLAY_NAME_BG: "Display name (BG)",
            CATEGORY: "Category",
            DEPARTMENT: "Department",
            VETERINARY_NUMBER: "Veterinary number",
            PRODUCER_NAME: "Producer",
            CATEGORY_NAME: "Category name",
            CREATE_CATEGORY: "Create Category",
            TAGS: "Tags",
            TAG_NAME: "Tag name",
            CREATE_TAG: "Create Tag",
            UNIT: "Unit",
            PRIMARY_UNIT: "Primary unit",
            SECONDARY_UNIT: "Secondary unit",
            SECONDARY_UNIT_KG: "Kg per secondary unit",
            HAS_SECONDARY_UNIT: "Has secondary unit",
            FIXED_WEIGHT: "Fixed weight",
            CATCH_WEIGHT: "Catch-weight",
            SHELF_LIFE_DAYS: "Shelf life days",
            ORIGIN_COUNTRY: "Origin country",
            ORIGIN_COUNTRY_NAME: "Origin country name",
            CREATE_ORIGIN_COUNTRY: "Create origin country",
            TEMPERATURE: "Temperature",
            PACKAGING: "Packaging",
            PACKAGING_LEVELS: "Packaging levels",
            PACKAGING_LEVEL: "Level {level}",
            PACKAGING_WEIGHT_KG: "Net kg per package",
            PACKAGING_UNIT_HINT: "1 {unit} = {kg} kg",
            ADD_PACKAGING_LEVEL: "Add packaging level",
            QUANTITY_BREAKDOWN: "Packaging qty",
            DESCRIPTION_MAPPING: "Description mapping (M-Description)",
            DESCRIPTION_MAPPING_REQUIRES_CATEGORY_MEAT:
                "Select a category with a meat mapping to choose a description mapping.",
            TAG_HINT_REQUIRES_NAME_CATEGORY: "Enter display name and category to see suggested tags.",
            TAG_RANK: {
                SAME_PRODUCT: "Used for this product name and category",
                SAME_CATEGORY: "Common for this category",
                OTHER: "Other categories",
            },
        },
        INVENTORY: {
            TITLE: "Inventory",
            ON_HAND: "On stock",
            RESERVED: "Reserved",
            FREE: "Free",
            EXPECTED: "Expected",
            AVERAGE_COST: "Avg. cost",
            AS_OF_DATE: "As of date",
            AS_OF_DATE_HINT: "Stock quantities include movements with action date on or before this day.",
            LOT_BREAKDOWN: "Lots",
            LOT_BREAKDOWN_TITLE: "On stock by lot",
            LOT_TOTAL: "Total",
            NO_LOT: "(no lot)",
            NO_LOTS: "No lot balances for this product.",
            PRODUCTION_DATE: "Production date",
            SCOPE_ORG_HINT:
                "No warehouse selected in the stock filter above — quantities are summed across all physical warehouses in the selected organization(s), or all organizations if none are selected.",
            TRANSIT_EXPECTED_HINT:
                "Transit warehouse: Expected = pipeline stock (no lots). On stock = finalized stock. When goods arrive: add lots, Finalize, then Convert to physical.",
            SINGLE_WAREHOUSE_FOR_LOTS:
                "Select exactly one warehouse in the stock filter above to view lot breakdown.",
            PROJECTED: "Projected",
            LATEST_PLANNED_DATE: "Latest planned",
            PLANNED_IN: "Planned in",
            PLANNED_OUT: "Planned out",
            REQUIREMENTS_LIST: "Requirements",
            REQUIREMENTS_LIST_TITLE: "Stock / requirements list",
            MRP_DATE: "Date",
            MRP_ELEMENT: "Element",
            MRP_REFERENCE: "Reference",
            MRP_QTY_CHANGE: "Receipt / reqmt",
            MRP_AVAILABLE: "Available qty",
            MRP_STOCK: "Stock",
            MRP_PO_ITEM: "PO item",
            MRP_SO_ITEM: "SO item",
            NO_REQUIREMENTS: "No planned PO/SO movements for this product in the selected scope.",
            GROUP_BY_WAREHOUSE: "Per warehouse",
            GROUP_BY_PRODUCT: "Grouped",
            LOT: "Lot",
            EXTERNAL_LOT: "External lot",
            DEAL: "Deal",
            COMPANY: "Company",
            DAYS_TO_EXPIRY: "Days to expiry",
            EXPIRY_DATE: "Expiry date",
            GROUP_BY_LOT: "Per lot",
            GROUP_BY_EXTERNAL_LOT: "Per external lot",
            GROUP_BY_DEAL: "Per deal",
            GROUP_BY_COMPANY: "Per company",
            WEIGHTED_AVG_COST: "Weighted avg. cost",
            TOTAL_INVENTORY_VALUE: "Total inventory value",
            NO_AVG_COST_HINT:
                "On-stock quantity is visible, but average cost is missing for some lines. Average cost is recorded when a receipt is finalized (physical or virtual) with a unit cost.",
            BLOCKED: "Blocked",
            AVAILABILITY: "Availability",
            GROUP_BY_AVAILABILITY: "Per free/blocked",
            STATUS_FREE: "Free",
            STATUS_BLOCKED: "Blocked",
            BLOCK_STOCK: "Block stock",
            BLOCK_QUANTITY: "Quantity to block",
            BLOCK_REASON: "Block reason",
            BLOCK_MAX_HINT: "Max blockable: {qty}",
            BLOCK_LOAD_LOTS_ERROR: "Could not load lots for blocking.",
            BLOCK_NO_LOTS: "No on-hand lots found for this product in the selected warehouse.",
            BLOCK_SAVE_ERROR: "Could not create quality hold.",
            HOLDS: "Holds",
            UNBLOCK_STOCK: "Unblock / holds",
            HOLDS_TITLE: "Quality holds",
            NO_HOLDS: "No active quality holds.",
            HOLDS_LOAD_ERROR: "Could not load quality holds.",
            RELEASE_HOLD: "Release",
            RELEASE_QUANTITY: "Quantity to release",
            RELEASE_REASON: "Release reason",
            CONFIRM_RELEASE: "Confirm release",
            RELEASE_ERROR: "Could not release quality hold.",
        },
        AVERAGE_COSTS: {
            TITLE: "Average cost by warehouse",
            AVG_COST: "Avg. unit cost",
            PACKAGING_COST_SUBTITLE: "qty · cost / pack",
            PACKAGING_COST_HINT: "Cost of 1 {unit} ({kg} kg)",
            INVENTORY_VALUE: "Inventory value (net)",
            TOTAL_INVENTORY_VALUE: "Total inventory value (filtered)",
            WEIGHTED_AVG_COST: "Weighted avg. unit cost",
            ON_HAND_TOTAL: "On stock (filtered)",
            SINGLE_WAREHOUSE_REQUIRED:
                "Select exactly one warehouse in the stock filter above. Average cost is always calculated per warehouse.",
            AS_OF_DATE_HINT:
                "Average unit cost is taken from the last receipt/issue with action date on or before this day.",
            REVALUE: "Revalue",
            REVALUE_TITLE: "Revalue average cost",
            REVALUE_HINT:
                "Sets the current average unit cost from today forward. Quantity stays unchanged; past sales keep their recorded cost.",
            REVALUE_TODAY_ONLY_HINT:
                "Revalue is available only when viewing today's average cost. Switch the as-of date to today to correct the current unit cost.",
            CURRENT_AVG_COST: "Current avg. unit cost",
            NEW_AVG_COST: "New avg. unit cost",
            REASON: "Reason",
            REVALUE_SUCCESS: "Average cost updated.",
            ACTIONS: "Actions",
        },
        PURCHASE_ORDERS: {
            TITLE: "Purchase orders",
            PAGE_TITLE: "Purchase order",
            DOCUMENT_CODE: "PO code",
            TOTAL_GROSS: "Total gross",
            NEW: "New purchase order",
            SUPPLIER: "Supplier",
            COUNTERPARTY_SALES_ORDER: "Counterparty sales order (intercompany)",
            COUNTERPARTY_SALES_ORDER_HINT: "Links this PO to the selling organization's sales order. Required for intercompany dropship auto-receipt to be importable.",
            INTERCOMPANY: "Intercompany",
            INTERCOMPANY_HINT:
                "When enabled, only companies linked to one of our organizations are shown (for intercompany PO/SO).",
            DESTINATION_WAREHOUSE: "Destination warehouse",
            DESTINATION_WAREHOUSE_HINT:
                "Physical warehouse where goods will be received when they arrive.",
            RECORD_IN_TRANSIT: "Record in transit",
            RECORD_IN_TRANSIT_HINT:
                "Records agreed PO quantity as expected supply in the transit virtual warehouse (no lots). Check Inventory → transit filter → Expected column.",
            RECORD_IN_TRANSIT_CONFIRM:
                "Record remaining PO quantity as expected supply in the transit warehouse? No lot numbers are required until goods physically arrive.",
            RECORD_IN_TRANSIT_SUCCESS:
                "Expected supply recorded in transit. Open Inventory, select the transit warehouse in the stock filter, and check the Expected column.",
            WAREHOUSE_REQUIRED_CONFIRM: "Destination warehouse is required before confirming.",
            WAREHOUSE_REQUIRED_RECEIPT: "Destination warehouse is required to create a receipt. Set it on the purchase order and save.",
            DEAL: "Deal (optional)",
            ORDER_DATE: "Order date",
            EXPECTED_DELIVERY: "Expected delivery",
            DEFAULT_VAT: "Default VAT %",
            CURRENCY: "Currency",
            LINES: "Order lines",
            QTY: "Quantity",
            UNIT_COST_NET: "Unit price (net)",
            LINE_TOTAL_NET: "Line total (net)",
            LINE_TOTAL_NET_HINT: "Edit total to back-calculate unit price from quantity.",
            TOTALS_PREVIEW: "Totals (live preview)",
            VAT: "VAT %",
            FULFILLED: "Fulfilled",
            REMAINING: "Remaining",
            ADD_LINE: "Add line",
            CONFIRM: "Confirm order",
            SHORT: "Short",
            AMEND_HINT:
                "Amendment mode: adjust quantities (not below received), remove lines with no receipts, add products below. Supplier and currency are locked. Use Short to close remaining quantity to what was received.",
            LINE_CANNOT_REMOVE: "Cannot remove — quantity already received",
            CREATE_RECEIPT: "Create receipt",
            STATUS_TIMELINE: "Status history",
            CONFIRM_CANCEL: "Cancel this purchase order?",
            CONFIRM_SHORT:
                "Set ordered quantities to what was received and close this purchase order? Unreceived lines will be removed.",
            TOTALS_SUMMARY: "Net {net} · VAT {vat} · Gross {gross}",
            RELATED_MOVEMENTS: "Related stock movements",
            NO_RELATED_MOVEMENTS:
                "No stock movements linked to this purchase order yet. Create a receipt from this order to record goods in.",
            RELATED_TRANSPORT_ORDERS: "Related transport orders",
            NO_RELATED_TRANSPORT_ORDERS:
                "No transport orders linked to this purchase order yet. Use Organize transport to plan inbound shipment.",
            RECEIPTS_FROM_TRANSPORT: "Receipts from transport",
            PURCHASE_ORDER: "Purchase order",
        },
        TRANSPORT_ORDERS: {
            TITLE: "Transport orders",
            PAGE_TITLE: "Transport order",
            DOCUMENT_CODE: "TO code",
            NEW: "New transport order",
            CARRIER: "Carrier",
            DEAL: "Deal (optional)",
            DIRECTION: "Direction",
            DIRECTION_LOCKED_HINT:
                "Direction is fixed for transport created from a purchase or sales order.",
            TRANSPORT_MODE: "Transport mode",
            LOADING_ADDRESS: "Loading address",
            UNLOADING_ADDRESS: "Unloading address",
            STOPS: "Route stops",
            ADD_LOADING_STOP: "+ Add loading point",
            ADD_UNLOADING_STOP: "+ Add unloading point",
            STOP_TYPE_LOADING: "Loading",
            STOP_TYPE_UNLOADING: "Unloading",
            STOP_ADDRESS_SOURCE: "Address source",
            STOP_SOURCE_WAREHOUSE: "Warehouse",
            STOP_SOURCE_COMPANY: "Company",
            STOP_SOURCE_FREE_TEXT: "Free text",
            STOP_SCHEDULED_AT: "Scheduled at",
            STOP_NOTES: "Notes",
            STOP_GOODS_DESCRIPTION: "Goods description",
            STOP_REFERENCE_NUMBER: "Reference number",
            REMOVE_STOP: "Remove point",
            STOP_FULFILLED: "Fulfilled",
            STOP_FULFILLMENT_NOT_TRACKED: "n/a",
            STOP_FULFILLMENT_NOT_TRACKED_HINT:
                "Stock fulfillment is not tracked for this point type on this transport direction (inbound tracks unloading; outbound tracks loading).",
            STOP_ALLOCATIONS: "Quantity allocation per point",
            STOP_ALLOCATIONS_HINT:
                "Save the lines first (so they have an id) before allocating their quantity across points.",
            STOP_BALANCE_WARNING_TITLE:
                "Loading and unloading quantities do not match for some lines:",
            CREATE_RECEIPT_FOR_STOP: "Create receipt — point {no}",
            CREATE_DELIVERY_FOR_STOP: "Create delivery — point {no}",
            GOODS_DESCRIPTION: "Goods description",
            APPROX_WEIGHT: "Approx. weight",
            APPROX_PALLETS: "Approx. pallets",
            PALLET_TYPE: "Pallet type",
            SCHEDULED_LOADING: "Scheduled loading",
            ETA: "ETA",
            AGREED_COST: "Agreed cost (net)",
            FINAL_COST: "Final cost (net)",
            CURRENCY: "Currency",
            TRUCK_PLATE: "Truck plate",
            VEHICLE_TYPE: "Type of vehicle",
            DRIVER_NAME: "Driver name",
            MODE_DATA: "Mode-specific details",
            LINES: "Planned lines",
            NO_LINES: "No product lines — header summary only is valid.",
            PLANNED_QTY: "Planned qty",
            PALLET_COUNT: "Pallets",
            DUPLICATE_LINE: "Duplicate line",
            DUPLICATE_PRODUCT_LINE: "Add another line for this product",
            AMEND_HINT:
                "Execution mode: refine planned lines with lots, expiry dates, and pallet counts; add or split products; update final cost and truck details. Carrier, route, and agreed cost stay locked.",
            REQUEST_PHASE: "Request phase",
            EXECUTION_PHASE: "Execution phase",
            OUTBOUND_LOT_WAREHOUSE_REQUIRED:
                "Link this transport order to a sales order with a source warehouse to select lots from stock.",
            TAB_REFERENCES: "References",
            TAB_CMR: "Shipments",
            TAB_SHIPMENTS: "Shipments",
            TAB_FILES: "Files",
            NO_REFERENCES: "No linked purchase orders, sales orders, or stock movements.",
            REF_TYPE: "Type",
            REF_DOCUMENT: "Document",
            SEND: "Send to carrier",
            CONFIRM: "Confirm agreed",
            MARK_IN_TRANSIT: "Mark in transit",
            MARK_DELIVERED: "Mark delivered",
            CREATE_RECEIPT: "Create receipt",
            CREATE_DELIVERY: "Create delivery",
            BOOK_TO_TRANSIT: "Book to transit",
            BOOK_TO_TRANSIT_HINT:
                "Goods are in transit. Use Book to transit to record stock in the transit virtual warehouse.",
            RECEIVE_TO_WAREHOUSE: "Receive to warehouse",
            RECEIVE_TO_WAREHOUSE_HINT:
                "Finalize transit receipt {code}, then receive goods into a physical warehouse.",
            IMPORT_FROM_VIRTUAL_RECEIPT: "Import from virtual receipt",
            IMPORT_VIRTUAL_RECEIPT_TITLE: "Import lots from virtual receipt",
            IMPORT_FROM_VIRTUAL_RECEIPT_HINT:
                "Select a finalized virtual receipt to replace planned lines with its lots. Quantities and lot details are taken from the receipt.",
            SELECT_VIRTUAL_RECEIPT: "Select a virtual receipt",
            NO_IMPORTABLE_VIRTUAL_RECEIPTS:
                "No finalized virtual receipts are available to import for this transport order.",
            IMPORT_VIRTUAL_RECEIPT_SUCCESS: "Lots imported from virtual receipt.",
            VIRTUAL_RECEIPT_LOT_COUNT: "{count} lot(s)",
            LINKED_TRANSPORT_ORDER: "Transport order",
            LINKED_FROM_TRANSPORT: "Created from transport",
            RECEIPTS_FROM_TRANSPORT: "Receipts from transport",
            DELIVERIES_FROM_TRANSPORT: "Deliveries from transport",
            CONFIRM_CANCEL: "Cancel this transport order?",
            ORGANIZE_TRANSPORT: "Organize transport",
            DIRECTIONS: {
                INBOUND: "Inbound",
                OUTBOUND: "Outbound",
                DIRECT: "Direct",
            },
            MODES: {
                ROAD: "Road",
                CONTAINER_ROAD: "Container (road)",
                CONTAINER_SEA: "Container (sea)",
                AIR_CARGO: "Air cargo",
                RAIL: "Rail",
                MULTIMODAL: "Multimodal",
                OTHER: "Other",
            },
            PALLET_TYPES: {
                EURO: "Euro",
                INDUSTRIAL: "Industrial",
                OTHER: "Other",
            },
            MODE: {
                CONTAINER_NO: "Container no.",
                VESSEL_NAME: "Vessel name",
                BILL_OF_LADING_NO: "Bill of lading no.",
                PORT_OF_LOADING: "Port of loading",
                PORT_OF_DISCHARGE: "Port of discharge",
                ETA_PORT: "ETA at port",
                AWB_NUMBER: "AWB number",
                FLIGHT_NUMBER: "Flight number",
                AIRPORT_ORIGIN: "Airport of origin",
                AIRPORT_DESTINATION: "Airport of destination",
                WAGON_NUMBER: "Wagon number",
                TRAIN_NUMBER: "Train number",
                LEGS_DESCRIPTION: "Legs description",
                DETAILS: "Details",
            },
        },
        INVOICES: {
            TITLE: "Invoices",
            PAGE_TITLE: "Invoice",
            NEW: "New invoice",
            LOADING: "Loading invoice…",
            LOAD_FAILED: "Could not load this invoice.",
            DOCUMENT_CODE: "Invoice code",
            COMPANY: "Company",
            TYPE: "Type",
            DIRECTION: "Direction",
            ISSUE_DATE: "Issue date",
            DUE_DATE: "Due date",
            EXTERNAL_NUMBER: "External number",
            SUPPLIER_INVOICE_NUMBER: "Supplier invoice number",
            DOCUMENT_NUMBER: "Document number",
            NOTES: "Notes",
            REVERSE_CHARGE: "Reverse charge",
            REVERSE_CHARGE_HINT:
              "Printed on the PDF only when VAT total is 0.",
            REVERSE_CHARGE_NEEDS_ZERO_VAT:
              "The reverse charge notice is printed only when VAT total is 0. Line VAT is still above 0.",
            NET: "Net",
            VAT: "VAT",
            GROSS: "Gross",
            TOTALS: "Totals",
            LOCKED: "Locked",
            TAB_HEADER: "Header",
            TAB_LINES: "Lines",
            TAB_SOURCES: "Sources",
            TAB_FILES: "Files",
            LINE_DESCRIPTION: "Description",
            MEASURE: "Measure",
            QTY: "Quantity",
            UNIT_PRICE_NET: "Unit price (net)",
            LINE_TOTAL_NET: "Line total (net)",
            NO_LINES: "No lines yet — add products or blank lines below.",
            ADD_LINE: "Add line",
            ISSUE: "Issue invoice",
            ISSUE_PROFORMA: "Issue proforma invoice",
            ISSUE_SUCCESS: "Invoice issued successfully.",
            ISSUE_PROFORMA_SUCCESS: "Proforma invoice issued successfully.",
            ISSUE_UNSAVED_TITLE: "Unsaved changes",
            ISSUE_UNSAVED_HINT:
              "You have changes that are not saved yet. Save them and issue this document?",
            SAVE_AND_ISSUE: "Save and issue",
            MERGE_LINES: "Merge lines",
            MERGE_SUCCESS: "Duplicate lines merged.",
            LOCK: "Lock",
            LOCK_SUCCESS: "Invoice locked for editing.",
            CREDIT_NOTE: "Credit note",
            CREATE_CREDIT_NOTE: "Create credit note",
            CREDIT_NOTE_EXTERNAL_HINT:
                "Enter the supplier credit note number from their document.",
            CLONE: "Clone",
            CLONE_INVOICE: "Clone invoice",
            CLONE_SUCCESS: "Draft invoice created from this document.",
            CLONE_EXTERNAL_HINT:
                "Enter a new supplier invoice number. The original number cannot be reused.",
            SOURCE_INVOICE: "Source document",
            SOURCE_INVOICE_HINT: "This document was created from the document below.",
            SOURCE_DOCUMENT: "Source document",
            DERIVED_INVOICES: "Related credit / debit notes",
            DERIVED_INVOICES_HINT: "Credit and debit notes created from this invoice.",
            CANCEL_CONFIRM: "Cancel this draft invoice?",
            READ_ONLY: "This invoice cannot be edited in its current status.",
            CREATE_MANUAL: "Create manual invoice",
            FILTER_DIRECTION: "Direction",
            STAT_DRAFT: "Draft",
            STAT_ISSUED: "Issued / paid",
            STAT_GROSS: "Total gross (filtered)",
            EXPORT_EXCEL: "Export to Excel",
            EXPORT_STARTED: "Export started. Please wait...",
            EXPORT_COMPLETED: "Export completed.",
            SOURCES: "Source stock movements",
            SOURCES_HINT: "Deliveries and receipts linked to this invoice. Unlink a movement to use it on another draft invoice.",
            NO_SOURCES: "No linked stock movements.",
            NEW_HINT: "Fill in header and lines, then save",
            PASS_THROUGH_EXTRA_COSTS: "Include pass-through extra costs",
            PASS_THROUGH_HINT: "Add transport and other extra costs as separate invoice lines for the customer.",
            CREATE_FROM_DELIVERY: "Create invoice",
            CREATE_FROM_DELIVERY_HINT: "Create a draft customer invoice from delivery {code}.",
            CREATE_FROM_RECEIPT: "Register supplier invoice",
            CREATE_FROM_RECEIPT_HINT: "Create a draft supplier invoice from receipt {code}, or add it to an existing draft invoice.",
            LINK_MODE_NEW: "Create a new draft invoice",
            LINK_MODE_EXISTING: "Add to an existing draft invoice",
            SELECT_DRAFT_INVOICE: "Draft invoice",
            NO_DRAFT_INVOICES: "No matching draft invoices for this company yet.",
            ALREADY_ON_DRAFT_INVOICE: "This movement is already on draft invoice {code}.",
            OPEN_DRAFT_INVOICE: "Open draft invoice",
            OPEN_DRAFT_INVOICE_SHORT: "Invoice {code}",
            ADD_TO_SELECTED_INVOICE: "Add to invoice",
            SOURCE_REMOVED: "Movement unlinked from invoice.",
            CREATE_PROFORMA: "Create proforma",
            CREATE_INVOICE_FROM_PROFORMA: "Create invoice from proforma",
            INTERNAL_REF: "Internal ref",
            FISCAL_NUMBER: "Fiscal number",
            BULK_CREATE_INVOICE: "Create invoice from selected",
            BULK_CREATE_HINT: "{count} delivery(ies) selected",
            BULK_REGISTER_SUPPLIER_INVOICE: "Register supplier invoice from selected",
            BULK_REGISTER_SUPPLIER_INVOICE_HINT: "{count} receipt(s) selected",
            MIXED_SELECTION_NOT_ALLOWED:
                "Select either receipts or deliveries, not both in one batch.",
            ONLY_SALE_DELIVERIES: "Only finalized sale deliveries can be selected for invoicing.",
            TYPES: {
                INVOICE: "Invoice",
                PROFORMA: "Proforma",
                CREDIT_NOTE: "Credit note",
                DEBIT_NOTE: "Debit note",
            },
            DIRECTIONS: {
                OUTGOING: "Outgoing",
                INCOMING: "Incoming",
            },
            OUTGOING_HINT: "Customer invoice — goods or services sold",
            INCOMING_HINT: "Supplier invoice — purchase or AP registration",
            TAX_EVENT_DATE: "Tax event date",
            ENGLISH_DOCUMENT: "English document",
            INCLUDE_COPY: "Include copy page",
            GFSI_SUPPLY_CHAIN_NOTE: "Print GFSI supply chain note",
            GFSI_SUPPLY_CHAIN_NOTE_TEXT:
                "Please note: The supply chain for the above-listed products is not fully covered by suppliers certified under GFSI-recognized standards",
            PAYMENT_METHOD: "Payment method",
            BANK_ACCOUNT: "Bank account",
            BANK_TRANSFER: "Bank transfer",
            CASH: "Cash",
            TRUCK_CONTAINER: "Truck / container",
            PLACE_OF_DEAL: "Place of deal",
            VAT_BASIS: "VAT transaction basis",
            INCLUDES_TRANSPORT: "Includes transport",
            DELIVERY_WEEK: "Delivery week",
            UNLABELED_TEXT: "Free text (no label)",
            PAYMENT_TERMS: "Payment terms / conditions",
            DUE_DAYS: "Due in days",
            SELLER_DETAILS: "Provider details (this invoice only)",
            BUYER_DETAILS: "Recipient details (this invoice only)",
            COMPANY_NAME: "Company name",
            REGISTRATION_NO: "Id. No / EIK",
            VAT_NO: "VAT No",
            CITY: "City",
            STREET: "Address",
            POSTAL_CODE: "Postal code",
            COUNTRY: "Country",
            MOL: "MOL / FR person",
            HS_CODE: "HS code",
            RECORD_PAYMENT: "Record payment",
            PAID_AMOUNT: "Paid amount",
            REMAINING_AMOUNT: "Remaining",
            PAYMENT_AMOUNT: "Payment amount",
            PAYMENT_DATE: "Payment date",
            PAYMENT_HISTORY: "Payment history",
            PAYMENT_STATUS: "Status",
            PAYMENT_RECORDED: "Recorded",
            PAYMENT_CANCELLED: "Cancelled",
            RECORDED_BY: "Recorded by",
            ANNUL_PAYMENT: "Annul",
            ANNUL_PAYMENT_CONFIRM: "Annul this payment? The paid total will be reduced by this amount.",
            NO_PAYMENTS: "No payments recorded yet.",
            FILTER_TRANSPORT: "Transport",
            TRANSPORT_YES: "With transport",
            TRANSPORT_NO: "Without transport",
            FILTER_OVERDUE: "Overdue",
            OVERDUE: "Overdue",
            REMINDER: "Reminder",
            REMINDER_DUE: "Reminder due",
            FILTER_REMINDER_DUE: "Reminder due",
            SEND_INVOICE: "Send invoice",
            SEND_REMINDER: "Send reminder",
            EMAIL_DIALOG_TITLE_INVOICE: "Send invoice email",
            EMAIL_DIALOG_TITLE_REMINDER: "Send payment reminder",
            EMAIL_RECIPIENTS: "Recipients",
            EMAIL_NO_RECIPIENTS:
                "This company has no general email with the invoice role. Add that role on the company, then try again.",
            EMAIL_NOTE: "Note for the email",
            EMAIL_NOTE_HINT: "Optional text that will be added to the email template.",
            EMAIL_REGENERATE_WARNING:
                "The invoice is saved first. The PDF is then regenerated from those saved details, and that file is the one recorded with the email.",
            EMAIL_SAVE_REQUIRED:
                "Save the invoice before sending. These changes cannot be stored with your current permissions.",
            EMAIL_CONFIRM: "Send email",
            EMAIL_RECORDED:
                "Email recorded with the current PDF. It is not delivered yet — the mail provider is not connected.",
            EMAIL_HISTORY: "Email history",
            EMAIL_HISTORY_HINT:
                "Each row keeps the PDF that was generated for that email. Delivery starts when a mail provider is connected.",
            EMAIL_HISTORY_EMPTY: "No emails recorded yet.",
            EMAIL_KIND: "Type",
            EMAIL_KIND_INVOICE: "Invoice",
            EMAIL_KIND_REMINDER: "Reminder",
            EMAIL_SENT_AT: "Recorded at",
            EMAIL_STATUS_SIMULATED: "Not delivered",
            EMAIL_DOWNLOAD_SNAPSHOT: "Sent PDF",
            AUTHOR_NAME: "Prepared by",
            SECTION_PARTIES: "Parties",
            SECTION_PARTIES_HINT: "Who issues the invoice, who receives it, and which deal it belongs to.",
            SECTION_DATES: "Dates",
            SECTION_DATES_HINT: "When the invoice is issued, when the tax event happens, and when it is due.",
            SECTION_TAX: "Currency and VAT",
            SECTION_TAX_HINT: "Currency, VAT rate and the legal basis printed on the document.",
            SECTION_PAYMENT: "Payment",
            SECTION_PAYMENT_HINT: "How the invoice is paid and which bank account is shown.",
            SECTION_DELIVERY: "Delivery",
            SECTION_DELIVERY_HINT: "Incoterms, transport and where the deal takes place.",
            SECTION_DOCUMENT: "Document text",
            SECTION_DOCUMENT_HINT: "Language, notes and extra lines printed on the PDF.",
            SECTION_PRINTED_PARTIES: "Printed company details",
            SECTION_PRINTED_PARTIES_HINT: "Used only on this invoice. They do not change the company record.",
          },
        CMR: {
            NUMBER: "CMR number",
            LANGUAGE: "Language",
            ISSUED_AT: "Issued at",
            GENERATE: "Generate CMR",
            REGENERATE: "Regenerate CMR",
            NO_DOCUMENT: "No CMR document yet. Generate a draft for road transport modes.",
            NOT_APPLICABLE: "CMR is only applicable for road and container (road) transport modes.",
            SAVE: "Save CMR",
            GROUP_SENDER: "1. Sender (name, address, country)",
            GROUP_CONSIGNEE: "2. Consignee (name, address, country)",
            GROUP_BOO_1: "By order of",
            GROUP_BOO_2: "By order of",
            GROUP_GOODS: "6. Description of goods",
            COMPANY_NAME: "Company name",
            ADDRESS: "Address",
            COUNTRY: "Country",
            VAT_NUMBER: "VAT number",
            PLACE_OF_DELIVERY: "3. Place of delivery of the goods",
            PLACE_AND_DATE_OF_TAKING_OVER: "4. Place and date of taking over of the goods",
            GOODS_NAME: "Name",
            HS_CODE: "HS code",
            GROSS_WEIGHT: "Gross weight",
            NET_WEIGHT: "Net weight",
            ADD_GOODS_LINE: "Add goods line",
            ESTABLISHED_IN: "21. Established in",
            ESTABLISHED_DATE: "Date",
            VEHICLE_REGISTRATION: "25. Registration number of the vehicle",
        },
        SHIPMENTS: {
            ADD: "Add set",
            EMPTY: "No CMR / trade document sets yet. Add a set to start filling the forms.",
            NO_PERMISSION: "You do not have permission to create shipment documents.",
            TITLE_ITEM: "Set {no}",
            LABEL: "Label",
            DELETE: "Delete set",
            CONFIRM_DELETE: "Delete this CMR and trade document set?",
            TAB_CMR: "CMR",
            TAB_TRADE_DOCUMENT: "Trade document",
        },
        TRADE_DOCUMENT: {
            NUMBER: "Document number",
            SAVE: "Save trade document",
            GENERATE: "Generate trade document",
            REGENERATE: "Regenerate trade document",
            SELLER: "Seller",
            BOO: "By order of",
            CONSIGNEE: "Consignee",
            TERMS_OF_DELIVERY: "Terms of delivery",
            DATE_OF_LOADING: "Date of loading",
            GROUP_ORIGIN: "Country of origin",
            ORIGIN_BORN: "Country where animals were born",
            ORIGIN_REARED: "Country where animals were reared",
            ORIGIN_SLAUGHTERED: "Country where animals were slaughtered",
            COUNTRY_OF_ORIGIN: "Country of origin",
            DESTINATION: "Destination",
            GROUP_GOODS: "Description of goods",
            GOODS_NAME: "Name",
            HS_CODE: "HS code",
            ADD_GOODS_LINE: "Add goods line",
            PALLETS_BOXES: "No. of pallets/boxes",
            NET_WEIGHT: "Net weight",
            GROSS_WEIGHT: "Gross weight",
            PLACE_OF_LOADING: "Place of loading",
            COLDSTORE_NUMBER: "Coldstore number",
            SLAUGHTERHOUSES: "Slaughterhouses",
            CUTTING_PLANT: "Cutting plant",
            LOT_BATCH_NUMBERS: "Lot / batch number",
            DATE_OF_SLAUGHTER_FREEZING: "Date of slaughter / freezing",
            PRODUCTION_DATE: "Production date",
            BEST_BEFORE: "Best before",
            TRUCK_NO: "Truck no.",
            KEEP_FROZEN: "Keep frozen",
            TRANSPORTATION_TEMPERATURE: "Transportation temperature",
            ISSUED_DATE: "Issued date",
        },
        SALES_ORDERS: {
            TITLE: "Sales orders",
            PAGE_TITLE: "Sales order",
            DOCUMENT_CODE: "SO code",
            TOTAL_GROSS: "Total gross",
            NEW: "New sales order",
            CUSTOMER: "Customer",
            COUNTERPARTY_PURCHASE_ORDER: "Counterparty purchase order (intercompany)",
            COUNTERPARTY_PURCHASE_ORDER_HINT:
                "Links this SO to the buying organization's purchase order. Required for intercompany dropship automation.",
            INTERCOMPANY: "Intercompany",
            INTERCOMPANY_HINT:
                "When enabled, only companies linked to one of our organizations are shown (for intercompany PO/SO).",
            SOURCE_WAREHOUSE: "Source warehouse",
            SOURCE_WAREHOUSE_HINT:
                "Required. Physical or virtual warehouse (e.g. drop-ship) goods ship from.",
            WAREHOUSE_REQUIRED_DELIVERY: "Source warehouse is required to create a delivery. Set it on the sales order and save.",
            DEAL: "Deal (optional)",
            ORDER_DATE: "Order date",
            REQUESTED_DELIVERY: "Requested delivery",
            DEFAULT_VAT: "Default VAT %",
            CURRENCY: "Currency",
            LINES: "Order lines",
            QTY: "Quantity",
            UNIT_PRICE_NET: "Unit price (net)",
            LINE_TOTAL_NET: "Line total (net)",
            VAT: "VAT %",
            FULFILLED: "Delivered",
            REMAINING: "Remaining",
            CONFIRM: "Confirm order",
            AMEND_HINT:
                "Amendment mode: adjust quantities (not below delivered), remove lines with no deliveries, add products below. Customer and currency are locked.",
            LINE_CANNOT_REMOVE: "Cannot remove — quantity already delivered",
            CREATE_DELIVERY: "Create delivery",
            CREATE_PO_FROM_SO: "Create PO from SO",
            STATUS_TIMELINE: "Status history",
            CONFIRM_CANCEL: "Cancel this sales order?",
            TOTALS_SUMMARY: "Net {net} · VAT {vat} · Gross {gross}",
            RELATED_MOVEMENTS: "Related deliveries",
            NO_RELATED_MOVEMENTS:
                "No deliveries linked to this sales order yet. Create a delivery from this order to record goods out.",
            RELATED_TRANSPORT_ORDERS: "Related transport orders",
            NO_RELATED_TRANSPORT_ORDERS:
                "No transport orders linked to this sales order yet. Use Organize transport to plan outbound shipment.",
            DELIVERIES_FROM_TRANSPORT: "Deliveries from transport",
            SALES_ORDER: "Sales order",
        },
        SALES: {
            TITLE: "Deliveries",
            PAGE_TITLE: "Delivery",
            NEW: "New delivery",
            SALES_ORDER: "Sales order",
            CUSTOMER: "Customer",
            SOURCE_WAREHOUSE: "Source warehouse",
            SOURCE_WAREHOUSE_HINT:
                "Required. Physical or virtual warehouse (e.g. drop-ship) goods ship from.",
            ORG_WAREHOUSE_AND_CUSTOMER_REQUIRED_SAVE:
                "Organization, source warehouse and customer are required.",
            DATE: "Delivery date",
            LOT: "Lot",
            LOT_PLACEHOLDER: "Select lot",
            NO_AVAILABLE_STOCK: "No stock available",
            DUPLICATE_PRODUCT_LINE:
                "Add another lot of this product (copies price; qty and lot stay empty)",
            LINES_LOCKED_HINT:
                "This delivery was auto-created from a virtual receipt. Lots and quantities are locked; only sale prices can be edited.",
            FINALIZE: "Finalize delivery",
            FINALIZED_MSG: "Delivery finalized — stock updated.",
            READ_ONLY_DOCUMENT: "This document is read-only (e.g. finalized movement).",
            STATUS_TIMELINE: "Status history",
        },
        WRITE_OFFS: {
            TITLE: "Write-offs",
            PAGE_TITLE: "Write-off",
            NEW: "New write-off",
            SOURCE_WAREHOUSE: "Source warehouse",
            SOURCE_WAREHOUSE_HINT: "Physical warehouse stock is written off from.",
            REASON: "Reason",
            NOTES: "Explanation",
            DATE: "Write-off date",
            ORG_WAREHOUSE_AND_REASON_REQUIRED_SAVE:
                "Organization, source warehouse and reason are required.",
            LOT: "Lot",
            LOT_PLACEHOLDER: "Select lot",
            NO_AVAILABLE_STOCK: "No stock available",
            DUPLICATE_PRODUCT_LINE: "Add another line for this product",
            FINALIZE: "Finalize write-off",
            FINALIZED_MSG: "Write-off finalized — stock updated.",
            READ_ONLY_DOCUMENT: "This document is read-only (e.g. finalized write-off).",
            STATUS_TIMELINE: "Status history",
        },
        TRANSFERS: {
            TITLE: "Transfers",
            PAGE_TITLE: "Warehouse transfer",
            NEW: "New transfer",
            SOURCE_WAREHOUSE: "From warehouse",
            SOURCE_WAREHOUSE_HINT: "Warehouse stock is transferred from.",
            DESTINATION_WAREHOUSE: "To warehouse",
            DESTINATION_WAREHOUSE_HINT: "Warehouse that receives the stock.",
            NOTES: "Notes",
            DATE: "Transfer date",
            ORG_AND_WAREHOUSES_REQUIRED_SAVE:
                "Organization, source and destination warehouses are required.",
            WAREHOUSES_MUST_DIFFER: "Source and destination must be different warehouses.",
            LOT: "Lot",
            LOT_PLACEHOLDER: "Select lot",
            NO_AVAILABLE_STOCK: "No stock available",
            DUPLICATE_PRODUCT_LINE: "Add another line for this product",
            FINALIZE: "Finalize transfer",
            FINALIZED_MSG: "Transfer finalized — stock moved to destination warehouse.",
            READ_ONLY_DOCUMENT: "This document is read-only (e.g. finalized transfer).",
            STATUS_TIMELINE: "Status history",
            PAIR_LINKED: "Linked transfer document",
        },
        TRANSFER_ORDERS: {
            TITLE: "Transfer orders",
            LIST_SUBTITLE:
                "Transfer orders involving your selected warehouses (from or to).",
            PAGE_TITLE: "Transfer order",
            NEW: "New transfer order",
            CODE: "Document code",
            SOURCE_WAREHOUSE: "From warehouse",
            SOURCE_WAREHOUSE_HINT:
                "Any warehouse in the organization — including warehouses outside your stock filter.",
            DESTINATION_WAREHOUSE: "To warehouse",
            DESTINATION_WAREHOUSE_HINT:
                "Your warehouses from the stock filter — where stock will be received.",
            REQUESTED_DATE: "Requested date",
            REQUESTED_DATE_FROM: "Requested date from",
            REQUESTED_DATE_TO: "Requested date to",
            NOTES: "Notes",
            ITEMS_COUNT: "Lines",
            LINES: "Product lines",
            ACTIONABLE_TO_SHIP: "To ship",
            ACTIONABLE_TO_RECEIVE: "To receive",
            REQUESTED_QTY: "Requested qty",
            SHIPPED_QTY: "Shipped qty",
            RECEIVED_QTY: "Received qty",
            LOT: "Lot",
            LOT_PLACEHOLDER: "Select lot",
            LOT_REQUIRED_SHIP: "Select a lot for every line before shipping.",
            DUPLICATE_PRODUCT_LINE: "Add another line for this product",
            ORG_AND_WAREHOUSES_REQUIRED_SAVE:
                "Organization, source and destination warehouses are required.",
            WAREHOUSES_MUST_DIFFER: "Source and destination must be different warehouses.",
            READ_ONLY_DOCUMENT: "This transfer order is no longer editable.",
            CONFIRM: "Confirm",
            CONFIRM_CONFIRM: "Confirm this transfer order?",
            CONFIRMED_MSG: "Transfer order confirmed.",
            SHIP: "Ship",
            CONFIRM_SHIP: "Ship this transfer order and create the outbound transfer?",
            SHIPPED_MSG: "Transfer order shipped.",
            RECEIVE: "Receive",
            CONFIRM_RECEIVE: "Receive this transfer order and create the inbound transfer?",
            RECEIVED_MSG: "Transfer order received.",
            RESOLVE_VARIANCE: "Resolve variance",
            CONFIRM_RESOLVE_VARIANCE: "Close this transfer order with the selected variance resolutions?",
            VARIANCE_RESOLVED_MSG: "Variance resolved — transfer order closed.",
            VARIANCE_MUST_RESOLVE: "Resolve all variance lines before closing.",
            VARIANCE_RESOLUTION: "Variance resolution",
            VARIANCE_ALLOCATION: "Variance allocation",
            VARIANCE_QTY_TO_SENDER: "Qty to sender",
            VARIANCE_QTY_TO_RECEIVER: "Qty to receiver",
            VARIANCE_ALLOCATION_SUM_MUST_MATCH:
                "The sender/receiver allocation must sum to the variance qty.",
            CANCEL: "Cancel order",
            CONFIRM_CANCEL: "Cancel this transfer order?",
            CANCELLED_MSG: "Transfer order cancelled.",
            SHIPPED_ACTION: "Shipped transfer",
            RECEIVED_ACTION: "Received transfer",
            VARIANCE: {
                PENDING: "Pending",
                RETURN: "Return",
                ACCEPTED_LOSS: "Accepted loss",
                WRITE_OFF: "Write-off",
                MANUAL: "Manual",
            },
        },
        MOVEMENTS: {
            TITLE: "Stock movements",
            SUBTITLE: "Receipts, deliveries, transfers, and other inventory actions",
            NEW_RECEIPT: "New receipt",
            NEW_MULTI_PO_RECEIPT: "Multi-PO receipt",
            NEW_DELIVERY: "New delivery",
            NEW_WRITE_OFF: "New write-off",
            NEW_TRANSFER: "New transfer",
            SALES_ORDER: "Sales order",
            TOTAL_NET: "Total (net)",
            TOTAL_COGS: "COGS (net)",
            TOTAL_MARGIN: "Margin (net)",
            MARGIN_PCT: "Margin %",
            INVENTORY_COST: "Inventory cost (net)",
            INVOICE: "Invoice",
            SUMMARY: "Filtered inventory value flow by organization",
            HAS_SO: "Linked to SO",
            HAS_SO_YES: "Yes",
            HAS_SO_NO: "No",
            INVOICE_SELECTION_HINT:
                "Select finalized receipts (same supplier) to register a supplier invoice, or finalized deliveries (same customer) to create a customer invoice. Movements already on a draft or issued invoice are not selectable.",
        },
        REVISIONS: {
            TITLE: "Stock revisions",
            LIST_SUBTITLE: "Counted closing balances per warehouse, newest first",
            PAGE_TITLE: "Stock revision",
            NEW: "New revision",
            EDIT_LAST: "Edit last revision",
            NEW_LABEL: "New",
            CODE: "Document code",
            COMPANY: "Company",
            WAREHOUSE: "Warehouse",
            FOR_DATE: "Revision date",
            FOR_DATE_HINT:
                "The day the count closes. A revision is an end-of-day operation, so it must fall after the previous finalized revision.",
            FOR_DATE_FROM: "Revision date from",
            FOR_DATE_TO: "Revision date to",
            NOTES: "Notes",
            STATUSES: {
                DRAFT: "Draft",
                FINALIZED: "Finalized",
                CANCELLED: "Cancelled",
            },
            STATUS_TIMELINE: "Status history",
            STEPS: {
                SCOPE: "Company and warehouse",
                COUNT: "Count sheet",
                REVIEW: "Review and confirm",
            },
            SCOPE_HINT: "Only physical warehouses can be revised.",
            OPEN_DRAFT_FOUND: "Revision {code} for {date} is already in progress. Continue it?",
            CONTINUE_DRAFT: "Continue draft",
            LATEST_FINALIZED: "Last finalized revision: {code} ({date})",
            NO_FINALIZED_REVISION: "This warehouse has no finalized revision yet.",
            EARLIEST_ALLOWED_DATE: "Earliest allowed date: {date}",
            EDIT_LAST_HINT:
                "Reopening removes the correction the revision produced and unlocks the period. Movements up to the revision date are recalculated on the next finalize, and manual lot corrections have to be redone.",
            REOPEN: "Reopen for editing",
            REOPEN_CONFIRM:
                "Reopen {code}? The correction it produced is removed, not reversed, and today's stock changes when you finalize again.",
            REOPENED: "Revision reopened for editing.",
            COLUMNS: {
                PRODUCT_ID: "Product ID",
                PRODUCT: "Product",
                TAGS: "Tags",
                TEMPERATURE: "Temperature",
                CATEGORY: "Category",
                DEPARTMENT: "Department",
                ORIGIN: "Origin",
                UNIT: "Unit",
                PREVIOUS_CLOSING: "Previous revision",
                MOVEMENTS_DELTA: "Change since",
                SYSTEM_QUANTITY: "Ideal quantity",
                COUNTED_QUANTITY: "Actual quantity",
                CONSUMPTION_QUANTITY: "Actual consumption",
                VARIANCE_QUANTITY: "Quantity difference",
                CONSUMPTION_VALUE: "Consumption value",
                VARIANCE_VALUE: "Difference value",
                UNIT_COST: "Unit cost",
                LOTS: "Lots",
            },
            COUNTED_HINT:
                "Actual quantity starts as the ideal quantity. Change it only where the count differs.",
            SHEET_SCOPE_HINT:
                "The sheet lists products with stock or movements in this warehouse. Use the product finder below to add an item that never moved here and enter a forced count.",
            PRODUCT_ADDED: "Product added to the count sheet.",
            PRODUCT_ALREADY_ON_SHEET: "This product is already on the current page.",
            SEARCH_PRODUCTS: "Filter sheet products, codes, tags",
            ONLY_VARIANCES: "Only differences",
            ONLY_COUNTED: "Only counted",
            LOADING_SHEET: "Loading count sheet…",
            NO_ROWS: "No products match the current filters.",
            NOT_COUNTED: "Not counted",
            SAVING_PAGE: "Saving page…",
            PAGE_SAVED: "Page saved",
            SAVE_FAILED: "Could not save this page. Fix the highlighted rows and try again.",
            SUMMARY: {
                TITLE: "Revision summary",
                TOTAL_ROWS: "Products in sheet",
                COUNTED_ROWS: "Counted",
                VARIANCE_ROWS: "With a difference",
                VARIANCE_QUANTITY: "Total difference",
                VARIANCE_VALUE: "Difference value",
                CONSUMPTION_VALUE: "Consumption value",
            },
            WARNINGS: {
                TITLE: "Reserved stock affected",
                HINT:
                    "The counted quantity is below what is already reserved for customers. The revision is still allowed — the reservations need renegotiating.",
                SHORTFALL: "Short by",
                RESERVED: "Reserved",
            },
            REALLOCATION_FAILURES: {
                TITLE: "Deliveries that need attention",
                HINT:
                    "These deliveries could not be re-matched to source lots after the correction. Review them and adjust the lots.",
            },
            FINALIZE: "Finalize revision",
            FINALIZE_CONFIRM:
                "Finalize {code} for {date}? The counted quantities become the closing balance of the warehouse and the period is locked.",
            FINALIZED: "Revision finalized.",
            FINALIZED_MOVEMENT: "Correction movement",
            NOTHING_TO_REVISE: "Nothing to revise: no stock and no counts were entered.",
            DELETE_DRAFT: "Delete draft",
            DELETE_DRAFT_CONFIRM: "Delete draft revision {code}? Entered counts are lost.",
            DELETED: "Draft revision deleted.",
            PREVIOUS_REVISION: "Previous revision",
            STARTED_BY: "Started by",
            FINALIZED_BY: "Finalized by",
            NEEDS_LOT_ASSIGNMENT: "Surplus without a lot — assign one through LOTS.",
            LOTS_DIALOG: {
                TITLE: "Correct quantities by lot",
                HINT:
                    "The system split rarely survives a physical count. Redistribute between lots, add a lot that turned up, or zero one that did not.",
                TARGET: "Counted quantity",
                ALLOCATED: "Allocated to lots",
                SYSTEM_QUANTITY: "System",
                COUNTED_QUANTITY: "Counted",
                LOT_NUMBER: "Lot",
                NO_LOT: "No lot",
                PRODUCTION_DATE: "Production",
                EXPIRY_DATE: "Expiry",
                ADD_LOT: "Add lot",
                NEW_LOT: "New lot",
                NEW_LOT_COST_HINT:
                    "A lot added by hand inherits the product average cost in this warehouse as of the revision date.",
                REMOVE_LOT: "Remove",
                MISMATCH: "Off by {difference} — allocate the full counted quantity to save.",
                BALANCED: "Lot quantities match the counted quantity.",
                SAVED: "Lot quantities saved.",
                ONLY_LATEST:
                    "Lots can only be corrected on the revision that currently closes this warehouse.",
            },
        },
        PRODUCT_MOVEMENTS: {
            TITLE: "Product movements",
            FILTER_TITLE: "Product filters",
            FILTER_HINT: "Pick a product and lot number to see every movement that batch took part in — inbound receipts and outbound sales, transfers, and write-offs. Click a lot number in the table to trace it. Widen or clear the date range if the lot is older than the table dates.",
            TRACE_LOT: "Show all movements for this lot",
            SIGNED_QTY: "Signed qty",
        },
        RECEIPTS: {
            TITLE: "Stock movements",
            PAGE_TITLE: "Receipt",
            LIST_SUBTITLE: "Receipts, issues, transfers, and other inventory actions",
            NEW: "New receipt",
            DOCUMENT_CODE: "Document code",
            MOVEMENT_TYPE: "Movement type",
            DIRECTION: "Direction",
            DIRECTION_IN: "In (+)",
            DIRECTION_OUT: "Out (−)",
            DIRECTION_NEUTRAL: "Neutral (±)",
            PURCHASE_ORDER: "Purchase order",
            LINKED_PO: "Linked PO",
            HAS_PO: "Linked to PO",
            HAS_PO_YES: "Yes",
            HAS_PO_NO: "No",
            COUNTERPARTY: "Counterparty",
            LINES: "Lines",
            PARENT_DOCUMENT: "Reverses",
            WAREHOUSE: "Warehouse",
            WAREHOUSE_HINT: "Physical warehouse for goods-in, or a virtual warehouse for agreed-but-not-yet-arrived stock.",
            SUPPLIER: "Supplier",
            DATE: "Receipt date",
            SUPPLIER_INVOICE_NO: "Supplier invoice no.",
            SUPPLIER_INVOICE_DATE: "Supplier invoice date",
            ACTION_CATEGORY: "Category",
            ACTION_CATEGORIES: {
                receipt: "Receipt",
                sale: "Sale / issue",
                transfer: "Transfer",
                write_off: "Write-off",
                production: "Production",
                adjustment: "Adjustment",
            },
            LOT_NUMBER: "Lot number",
            EXTERNAL_LOT: "External lot",
            QUALITY_STATUS: "Availability",
            QUALITY_STATUS_FREE: "Free",
            QUALITY_STATUS_BLOCKED: "Blocked",
            QUALITY_HOLD_REASON: "Block reason",
            LOT_OPTIONAL_UNTIL_FINALIZE: "Optional until finalize (required when goods arrive).",
            EXPIRY: "Expiry",
            AVAILABLE_FROM: "Available from",
            AVAILABLE_FROM_HINT: "Optional informational date only. Does not affect Expected quantity in Inventory.",
            EXPECTED_SUPPLY_HINT:
                "Expected pipeline supply in transit — no lots required yet. When goods arrive: add lot numbers, Finalize, then Convert to physical at the PO destination warehouse.",
            TRANSIT_BOOKING_HINT:
                "Expected pipeline supply — add real lot numbers when goods arrive, then Finalize and Convert to physical.",
            SAVE_AS_EXPECTED: "Save as expected supply",
            SAVE_AS_EXPECTED_MSG:
                "Expected supply saved. Visible in Inventory when the transit warehouse is selected (Expected column).",
            FINALIZE_REQUIRES_LOTS_HINT:
                "Lot numbers are required before Finalize. Add real batch details when goods physically arrive.",
            DUPLICATE_PRODUCT_LINE:
                "Add another lot of this product (copies cost; qty, lot, and dates stay empty)",
            FINALIZE: "Finalize receipt",
            FINALIZED_MSG: "Receipt finalized — stock updated.",
            SUPPLIER_HEADER_EDITABLE_HINT:
                "Receipt is finalized. You can still set the supplier and supplier invoice reference before registering the supplier invoice.",
            SUPPLIER_REQUIRED_FOR_INVOICE:
                "Select a supplier before registering the supplier invoice.",
            REVERSE: "Storno",
            CONFIRM_REVERSE: "Create reversal (storno) for this receipt?",
            CONVERT_TO_PHYSICAL: "Convert to physical flow",
            CONVERT_TO_PHYSICAL_HINT:
                "Neutralize virtual stock and open a physical supplier receipt at the selected warehouse.",
            CONVERT_TO_PHYSICAL_SUCCESS: "Virtual stock neutralized. Open the new physical receipt to add lots and finalize.",
            PHYSICAL_DESTINATION_WAREHOUSE: "Physical destination warehouse",
            READ_ONLY_DOCUMENT: "This document is read-only (e.g. storno or finalized movement).",
            EXTRA_COSTS: "Extra costs",
            EXTRA_CATEGORY: "Type",
            EXTRA_SERVICE: "Service",
            AMOUNT_NET: "Amount (net)",
            ALLOCATION: "Allocation",
            ADD_EXTRA_COST: "Add extra cost",
            IMPORT_TRANSPORT_COST: "Import transport cost from linked TO",
            IMPORT_TRANSPORT_COST_SUCCESS: "Transport cost imported from linked transport order.",
            LINES_LOCKED_HINT:
                "This receipt was auto-created from an intercompany delivery. Lots and quantities are locked; only prices can be edited.",
            STATUS_TIMELINE: "Status history",
            ALLOCATED_OF: "Allocated {allocated} / {total}",
            EXTRA_ALLOC_REMAINING: "{remaining} left",
            EXTRA_ALLOC_MAX: "max {max}",
            EXTRA_ALLOC_FULL: "full",
            EXTRA_ALLOCATIONS_CLEARED:
                "Line allocations were cleared because the service total is lower than the sum already distributed.",
            EXTRA_ALLOC_OVER_TOTAL: "over-allocated — reduce a line first",
            LINE_ALLOC: "Alloc.",
            EXTRA_COSTS_HINT: "Net amounts feed average cost. Service VAT is for document totals only.",
            COST: "Cost",
            UNIT_COST_SHORT: "unit",
            LINE_TOTAL_SHORT: "total",
            MORE_DETAILS: "More details",
            HIDE_DETAILS: "Hide details",
        },
        RECEIVING_SESSION: {
            PAGE_TITLE: "Multi-PO receipt",
            NEW: "New multi-PO receipt",
            SESSION: "Receiving session",
            START_HINT:
                "Select two or more purchase orders from the same supplier, organization, and destination warehouse.",
            SELECT_POS: "Purchase orders",
            START_SESSION: "Start receiving session",
            ACTIVE_POS: "Active purchase orders",
            WORKFLOW_HINT:
                "Search for a product below, then enter lot details and allocate quantities across the selected POs before they appear in the lines table.",
            PROCESSED_LOTS: "Processed lots (this session)",
            NO_LOT_ENTRIES: "No lot lines yet. Use the product finder to add stock.",
            LINE_QTY: "Line quantity",
            EXTERNAL_LOT: "External lot",
            PALLET_NUMBER: "Pallet no.",
            PRODUCTION_DATE: "Production date",
            UNIT_COST: "Unit cost (net)",
            VAT_RATE: "VAT %",
            PO_ALLOCATION: "Allocate across purchase orders",
            PO_REMAINING: "Remaining on PO",
            ALLOCATE_QTY: "Allocate",
            ALLOCATION_REMAINING: "Remaining to allocate: {remaining} (line total {total})",
            ACCEPT_ALLOCATION: "Accept allocation",
            ADD_LOT_ENTRY: "Add lot line",
            EDIT_LOT_ENTRY: "Edit lot line",
            PO_SPLIT: "PO split",
            FINALIZE_SESSION: "Finalize session",
            CONFIRM_REMOVE_LOT_ENTRY: "Remove this lot entry and its receipt lines?",
        },
        STATUSES: {
            PO: {
                DRAFT: "Draft",
                SENT: "Sent",
                CONFIRMED: "Confirmed",
                PARTIALLY_RECEIVED: "Partially received",
                RECEIVED: "Received",
                CANCELLED: "Cancelled",
            },
            RECEIPT: {
                DRAFT: "Draft",
                EXPECTED: "Expected",
                FINALIZED: "Finalized",
                REVERSED: "Reversed",
                CANCELLED: "Cancelled",
            },
            SO: {
                DRAFT: "Draft",
                CONFIRMED: "Confirmed",
                PARTIALLY_DELIVERED: "Partially delivered",
                DELIVERED: "Delivered",
                INVOICED: "Invoiced",
                CLOSED: "Closed",
                CANCELLED: "Cancelled",
            },
            TO: {
                DRAFT: "Draft",
                SENT: "Sent",
                AGREED: "Agreed",
                IN_TRANSIT: "In transit",
                DELIVERED: "Delivered",
                CANCELLED: "Cancelled",
            },
            CMR: {
                DRAFT: "Draft",
                ISSUED: "Issued",
                SIGNED: "Signed",
            },
            SALE: {
                DRAFT: "Draft",
                EXPECTED: "Expected",
                FINALIZED: "Finalized",
                REVERSED: "Reversed",
                CANCELLED: "Cancelled",
            },
            WRITE_OFF: {
                DRAFT: "Draft",
                EXPECTED: "Expected",
                FINALIZED: "Finalized",
                REVERSED: "Reversed",
                CANCELLED: "Cancelled",
            },
            TRANSFER: {
                DRAFT: "Draft",
                EXPECTED: "Expected",
                FINALIZED: "Finalized",
                REVERSED: "Reversed",
                CANCELLED: "Cancelled",
            },
            INVOICE: {
                DRAFT: "Draft",
                ISSUED: "Issued",
                PARTIALLY_PAID: "Partially paid",
                PAID: "Paid",
                CANCELLED: "Cancelled",
            },
            TRANSFER_ORDER: {
                DRAFT: "Draft",
                CONFIRMED: "Confirmed",
                SHIPPED: "Shipped",
                RECEIVED: "Received",
                CANCELLED: "Cancelled",
                CLOSED: "Closed",
            },
        },
        PRODUCT_CATEGORIES: {
            TITLE: "Product Categories",
            CREATE: "Create Category",
            EDIT: "Edit Category",
            DEPARTMENT: "Department",
            PRODUCTS_COUNT: "Products",
            MEAT_MAPPING: "Meat mapping (M-MeatGroup)",
        },
        PRODUCT_DEPARTMENTS: {
            TITLE: "Product Departments",
            CREATE: "Create Department",
            EDIT: "Edit Department",
            CATEGORIES_COUNT: "Categories",
        },
        PACKAGINGS: {
            TITLE: "Packagings",
            CREATE: "Create Packaging",
            EDIT: "Edit Packaging",
            TYPE: "Type",
            SYSTEM: "System",
            CUSTOM: "Custom",
            USAGE_COUNT: "Used by",
            SYSTEM_HINT: "System packagings can be renamed or deactivated, but they cannot be deleted.",
        },
        UNITS: {
            TITLE: "Units",
            CREATE: "Create Unit",
            EDIT: "Edit Unit",
            TYPE: "Type",
            SYSTEM: "System",
            CUSTOM: "Custom",
            DECIMALS: "Decimals",
            DECIMALS_RANGE: "Decimals must be a whole number between 0 and 6.",
            NAME_BG: "Bulgarian name",
            CODE_BG: "Bulgarian abbreviation",
            USAGE_COUNT: "Used by products",
            SYSTEM_HINT: "System unit codes cannot be changed, and system units cannot be deleted.",
            KILOGRAM_HINT: "Kilogram is the primary stock unit. Its code cannot be changed, it cannot be deactivated, and it cannot be deleted.",
        },
    },
    ALIASES: {
        TITLE: "Edit Aliases",
        SUB_TITLE: "Edit Aliases",
        LIST: "Aliases",
        TABLE_COLUMNS: {
          VALUE: "Original",
          FORMATTED_VALUE: "Clean",
          NUMBER_OF_TYPE: "Number of type"
        },
        EMPTY_VALUE_ERROR_MESSAGE: "Please fill all selected values!"
    },
    MAPPINGS: {
        EDIT: "Edit Mapping",
        CREATE: "Create Mapping",
        LIST: "Mappings",
        EDIT_VALUES: "Edit Mapping Values",
        EXPAND_HIDE_ALL: "Expand/Hide All",
        ADD_MAPPING_VALUE: "Add Mapping Value",
        EDIT_MAPPING_VALUE: "Edit Mapping Value",
        VALUE_LABEL: "Value",
        GROUP_VALUE_LABEL: "Group Value",
        GROUP_LABEL: "Group",
        PARENT_LABEL: "Parent",
        TAG: "Tag",
        DOWNLOAD_TEMPLATE: "Download Template",
        IMPORT_MAPPING: "Import Mapping",
        DOWNLOAD_BIG_FILE_CONFIRM: "The file is too big and if you try to import it, this may slow down the server.",
        LIVE_LIST_NOT_IMMEDIATELY_APPEARS: "The changes is not immediately appears in the live list. It may take a few seconds.",
    },
    UNIT_CONVERSIONS: {
        TITLE: "Unit Conversions",
        CREATE: "Create Unit Conversion",
        EDIT: "Edit Unit Conversion",
        UNIT: "Unit",
        TO_KG: "To KG",
    },
    TRANSPORT_DATA: {
      TITLE: "Transport Data",
      ADD_TRANSPORT_DATA: "Add transport data",
      EDIT_TRANSPORT_DATA: "Edit transport data",
      COUNTRY_A: "Country A",
      COUNTRY_B: "Country B",
      DISTANCE: "Distance",
      PRICE: "Price",
    },
    LIVE_LIST: {
        TITLE: "Live List",
        COST_BASE: "Cost Base",
        WEIGHTED_AVERAGE_PRICE: "Weighted Average Price",
        MIN_PRICE_OF_RANK: "Min Price Of Rank",
        MAX_PRICE: "Max Price",
        APPROVED: "Approved",
        LEAD: "Lead",
        INDICATORS: {
            HAS_NEW_APPROVED_OFFERS: "New Approved Offers",
            HAS_NEW_NOT_APPROVED_OFFERS: "New Not Approved Offers",
            HAS_EXPIRED_OFFERS: "Expired Offers",
            AUTO_APPROVED: "Auto Approved",
        },
        FILTERS: {
            LAST_AUTO_UPDATED: "Last Auto Updated",
            MANNUALY_SET_COST_BASE: "Manually Set Cost Base",
            NEW_OFFERS_THAT_ARE_NOT_APPROVED: "New Offers That Are Not Approved",
            NEW_APPROVED_OFFERS_WITH_MANNUALY_SET_COST_BASE: "New Approved Offers With Manually Set Cost Base",
            NEWLY_ARRIVED_OFFERS: "Newly-arrived Offers",
        }
    },
    PRICE_LISTS: {
      LIST: "Price Lists",
      CREATE: "Create Price List",
      EDIT: "Edit Price List",
      ADD: "Add Price List",
      STEP_1: "Base",
      STEP_2: "Price List",
      STEP_3: "Preview",
      STEP_4: "Publish",
      FOR_GROUP_OF_CONTACTS: "Select Group of Contacts",
      DATA_LOSS_CONFIRM: "This action may cause data loss. Are you sure you want to continue?",
      COST_BASE: "Cost Base",
      TRANSPORT_COST: "Transport Cost",
      CLIENT_PRICE: "Client Price",
      WEIGHTED_AVERAGE_PRICE: "Weighted Average Price",
      MIN_PRICE_OF_RANK: "Min Price Of Rank",
      MAX_PRICE: "Max Price",
      LEAD: "Lead",
      PUBLISH_CONFIRM: "Are you sure you want to publish this price list?",
      PUBLISHED_TYPE: "Published Via",
      PUBLISHED_DATE: "Published Date",
      SHARE_TO_USERS: "Share to Users",
      SHARE_TO_TEAMS: "Share to Teams",
      PUBLISH_BUTTON: "Publish",
      INCLUDE_TRANSPORT_COST: "Transport Cost",
    },
    PRICING: {
        EDIT: "Edit Pricing",
        CREATE: "Create Pricing",
        LIST: "Pricing",
        ACTIVE: "Active",
        CREATED_BY: "Created By",
        PUBLISHED_BY: "Published By",
        EXPIRE_DATE: "Expire Date",
        PUBLISHED_DATE: "Published Date",
        CLONE: "Clone",
    },
};
